import actions from '@/store/modules/train-config/actions.js'
import mutations from '@/store/modules/train-config/mutations.js'
import getters from '@/store/modules/train-config/getters.js'
import {base_state} from '@/store/modules/base/state'

const state = {
  ...base_state,
  'api_module': 'train_config'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}